import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate, useParams, Link } from "react-router-dom";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import Switch from "../../components/Switch";
const ShowSchedule = () => {
  const { id, name } = useParams();
  const [scheduleData, setScheduleData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [selectedRecord, setSelectedRecord] = useState(null);

  const navigate = useNavigate();
  const token = getCookie("token");
  const userid = getCookie("userid");

  useEffect(() => {
    if (!token || !userid) {
      navigate("/login");
      return;
    }
    fetchScheduleData();
  }, [token, userid, navigate, id]);

  const fetchScheduleData = async () => {
    try {
      const response = await axios.post(
        'https://api.dqr-display-tms.eventum.co.in/api/CatalogSchedulerInfoOperation/Search',
        {
          schedulerid: parseInt(id),
          ispageload: true,
          pagesize: 1000,
          currentpageno: 0,
          withoutpagination: true,
          pagedirection: "string"
        },
        {
          headers: {
            'accept': 'text/plain',
            'UserId': userid,
            'X-Authorization': token,
            'Content-Type': 'application/json-patch+json'
          }
        }
      );

      if (response.data && response.data.data) {
        setScheduleData(response.data.data);
      } else {
        setMessage("No schedule data found");
      }
    } catch (error) {
      console.error("Error fetching schedule data:", error);
      setMessage("Failed to fetch schedule data");
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/schedulelist");
  };

  const handleDelete = async (recordId) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      try {
        await axios.post(
          'https://api.dqr-display-tms.eventum.co.in/api/CatalogSchedulerInfoOperation/Delete',
          { id: recordId },
          {
            headers: {
              'accept': 'text/plain',
              'UserId': userid,
              'X-Authorization': token,
              'Content-Type': 'application/json-patch+json'
            }
          }
        );
        fetchScheduleData(); // Refresh data
      } catch (error) {
        console.error("Error deleting record:", error);
      }
    }
  };

  const handleToggle = async (record) => {
    const apiUrl = record.active
      ? 'https://api.dqr-display-tms.eventum.co.in/api/CatalogSchedulerInfoOperation/UpdateStatus/Deactive'
      : 'https://api.dqr-display-tms.eventum.co.in/api/CatalogSchedulerInfoOperation/UpdateStatus/Active';

    try {
      await axios.post(apiUrl, { id: record.id }, {
        headers: {
          'accept': 'text/plain',
          'UserId': userid,
          'X-Authorization': token,
          'Content-Type': 'application/json-patch+json'
        }
      });
      fetchScheduleData(); // Refresh data
    } catch (error) {
      console.error("Error toggling status:", error);
    }
  };

  const handleUpdate = (recordId) => {
    navigate(`/updateschedulerinfo/${id}/${recordId}`);
  };

  const handleAdd = () => {
    navigate(`/addschedulerinfo/${id}`);
  };

  if (loading) {
    return (
      <>
        <Menu />
        <div className="wrapper">
          <div className="content-wrapper">
            <section className="content">
              <div className="container-fluid">
                <div className="d-flex justify-content-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Show Schedule</h1>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item">
                      <Link to="/schedulelist">Schedules</Link>
                    </li>
                    <li className="breadcrumb-item active">Show Schedule</li>
                  </ol>
                </div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">Schedule Information - {name}</h3>
                      <div className="card-tools">
                        <button
                          type="button"
                          className="btn btn-sm btn-success"
                          onClick={handleAdd}
                        >
                          <i className="fas fa-plus mr-1"></i>
                          Add New
                        </button>
                      </div>
                    </div>
                    <div className="card-body">
                      {message && (
                        <div className={`alert ${message.includes("successfully") ? "alert-success" : "alert-danger"}`} role="alert">
                          {message}
                        </div>
                      )}

                      {scheduleData && Array.isArray(scheduleData) && scheduleData.length > 0 ? (
                        <table className="table table-hover table-striped">
                           <thead className="thead-light" style={{
                            backgroundColor: 'var(--surface2)',
                            color: 'var(--text)',
                            borderColor: 'var(--border)'
                          }}>
                            <tr>
                              <th>ID</th>
                              <th>Catalogue Name</th>
                              <th>Scheduler Name</th>
                              <th>Start Time</th>
                              <th>End Time</th>
                              <th>Status</th>
                              <th>Created Date</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {scheduleData.map((record) => (
                              <tr key={record.id}>
                                <td>{record.id}</td>
                                <td>{record.catalogname || "-"}</td>
                                <td>{record.schedulername || "-"}</td>
                                <td>{record.starttime || "-"}</td>
                                <td>{record.endtime || "-"}</td>
                                <td>
                                  <span className={`badge ${record.active ? 'badge-success' : 'badge-danger'}`}>
                                    {record.active ? 'Active' : 'Inactive'}
                                  </span>
                                </td>
                                <td>{record.createddate ? new Date(record.createddate).toLocaleString() : "-"}</td>
                                <td>
                                  <div className="btn-group">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-warning mr-1"
                                      onClick={() => handleUpdate(record.id)}
                                    >
                                      <i className="fas fa-edit mr-1"></i>
                                      Update
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-danger mr-1"
                                      onClick={() => handleDelete(record.id)}
                                    >
                                      <i className="fas fa-trash mr-1"></i>
                                      Delete
                                    </button>
                                    {/* <button
                                      type="button"
                                      className={`btn btn-sm ${record.active ? 'btn-warning' : 'btn-success'}`}
                                      onClick={() => handleToggle(record)}
                                    >
                                      <i className={`fas ${record.active ? 'fa-toggle-off' : 'fa-toggle-on'} mr-1`}></i>
                                      {record.active ? 'Deactive' : 'Active'}
                                    </button> */}

                                    <Switch
                                      isOn={record.active}
                                      handleToggle={() => handleToggle(record)}
                                      id={record.id}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <div className="text-center">
                          <p>No schedule data available</p>
                        </div>
                      )}

                      <div className="card-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleBack}
                        >
                          <i className="fas fa-arrow-left mr-2"></i>
                          Back to List
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ShowSchedule;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
